import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CONFIG_CONSTANTS, API_CONSTANTS } from '@finder/shared/constants/app.constants';
import { ConfigService } from '@finder/core/config.service';
import getApiBase from '@finder/shared/utils/string/getApiBase';
import { FormResponse } from '@finder/features/eve/components/form-result/form-result.interface';

const apiUrlKey = CONFIG_CONSTANTS.apiUrlKey;
const defaultVersionKey = CONFIG_CONSTANTS.defaultVersionKey;
const eveTimeoutKey = CONFIG_CONSTANTS.eveTimeoutKey;

@Injectable()
export class ContentInspectionConnectorService {

    private baseUrl: string;
    private version: string;

    constructor(
        private http: HttpClient,
        private config: ConfigService,
    ) {
        this.baseUrl = this.config.getValue(apiUrlKey);
        this.version = this.config.getValue(defaultVersionKey);
    }

    /**
     * Makes a request to get the form config for EVE.
     *
     * @param id            facility ID
     * @param partySize     the party size
     * @param searchDate    the date to search
     * @param params        the params for the request
     * @param version       endpoint version (optional)
     */
    public getEveFormConfig(
        version?: string
    ): Observable<any> {
        const url = this.constructBaseUrl(
            API_CONSTANTS.eveFormConfigEndpoint,
            this.baseUrl,
            version
        );

        return this.http.get(url);
    }

    /**
     * Makes a request to post the form data and get a response for EVE.
     *
     * @param id            facility ID
     * @param partySize     the party size
     * @param searchDate    the date to search
     * @param params        the params for the request
     * @param version       endpoint version (optional)
     */
    public inspectEveForm(
        data: any,
        version?: string,
    ): Observable<FormResponse> {
        const url = this.constructBaseUrl(
            API_CONSTANTS.eveInspectFormEndpoint,
            this.baseUrl,
            version
        );

        const timeoutValue = this.config.getValue(eveTimeoutKey);

        return this.http.post(url, data, {
            headers: { 'X-Disney-Internal-WebApi-Eve-Request-Timeout': timeoutValue },
        }) as Observable<FormResponse>;
    }

    private constructBaseUrl(endpoint: string, baseUrl: string, version: string = this.version): string {
        const apiBase = getApiBase(baseUrl, version);

        return `${apiBase}/${endpoint}`;
    }
}
